import { getCountryConfig } from '@infra/utils';
import { Tag } from 'antd';

export const CountryTag = ({ countryId }: { countryId: number | null }) => {
  if (!countryId) return null;

  const config = getCountryConfig(countryId);
  if (!config) return null;

  return <Tag color={config.color}>{config.name}</Tag>;
};
